var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPassword(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2,22.29H13.8c-1.1,0-2,.9-2,2v15.62c0,1.1,.9,2,2,2h20.4c1.1,0,2-.9,2-2v-15.62c0-1.1-.9-2-2-2Zm-8.2,13.62c0,1.11-.89,2-2,2s-2-.89-2-2v-8.18c0-1.11,.89-2,2-2s2,.89,2,2v8.18Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.2,18.29H15.54v-3.74c0-4.66,3.79-8.46,8.46-8.46,3.91,0,7.38,2.78,8.25,6.6,.24,1.08,1.3,1.75,2.39,1.51,1.08-.25,1.75-1.32,1.51-2.39-1.28-5.63-6.39-9.71-12.15-9.71-6.87,0-12.46,5.59-12.46,12.46v4.19c-2.19,.89-3.74,3.05-3.74,5.56v15.62c0,3.31,2.69,6,6,6h20.4c3.31,0,6-2.69,6-6v-15.62c0-3.31-2.69-6-6-6Zm2,21.62c0,1.1-.9,2-2,2H13.8c-1.1,0-2-.9-2-2v-15.62c0-1.1,.9-2,2-2h20.4c1.1,0,2,.9,2,2v15.62Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,25.73c-1.11,0-2,.89-2,2v8.18c0,1.11,.89,2,2,2s2-.89,2-2v-8.18c0-1.11-.89-2-2-2Z",
    fill: outlineColor
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPassword);
export default __webpack_public_path__ + "static/media/ico-password.96ce37c573d2f3f18b3ae8e13754a53a.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;